import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { AuthorizeNetConfigurationCard } from './components/authorizenet-configuration-card'
import { AuthorizeNetAcceptJSCard } from './components/authorizenet-acceptjs-card'

interface AuthorizeNetProcessorDetailsPageProps {
    processor: ProcessorDetails
}

export const AuthorizeNetProcessorDetailsPage = ({ processor }: AuthorizeNetProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader
                type="authorizenet"
                processor={processor}
            />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <AuthorizeNetConfigurationCard processor={processor} />
            <AuthorizeNetAcceptJSCard processor={processor} />
        </>
    )
}
